import { PING_INTERVAL_PRESETS, formatPingInterval, secondsToMinutes } from "../lib/ping-interval";

/** Minutes-based picker for duty ping interval (stored as seconds in the policy). */
export function PingIntervalPicker({
  pingIntervalSeconds,
  onChange,
  disabled = false,
}: {
  pingIntervalSeconds: number;
  onChange: (seconds: number) => void;
  disabled?: boolean;
}) {
  const minutes = secondsToMinutes(pingIntervalSeconds);

  return (
    <fieldset className="tpl__fieldset ping-interval" disabled={disabled}>
      <legend className="tpl__legend">Ping interval</legend>
      <p className="setup__field-hint">
        How often the mobile app sends an on-duty location ping while a guard is clocked in.
      </p>
      <div className="shift-duration__presets" role="group" aria-label="Common ping intervals">
        {PING_INTERVAL_PRESETS.map((preset) => (
          <button
            key={preset.seconds}
            type="button"
            className={`toggle-chip${pingIntervalSeconds === preset.seconds ? " toggle-chip--on" : ""}`}
            aria-pressed={pingIntervalSeconds === preset.seconds}
            onClick={() => onChange(preset.seconds)}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <label className="tpl__field">
        Custom interval (minutes)
        <select
          value={minutes}
          onChange={(event) => onChange(Number(event.target.value) * 60)}
          aria-label="Ping interval minutes"
        >
          {Array.from({ length: 60 }, (_, index) => index + 1).map((value) => (
            <option key={value} value={value}>
              {value === 1 ? "1 minute" : `${value} minutes`}
            </option>
          ))}
        </select>
      </label>
      <p className="shift-duration__summary" role="status">
        <span className="shift-duration__summary-length">{formatPingInterval(pingIntervalSeconds)}</span>
      </p>
    </fieldset>
  );
}
